import React from 'react';
import { getTemplates } from "../templates";

export default function TemplateSelector() {
    const onSelect = (tmpl) => {
        const host = window.location.hostname;
        let url = host === 'localhost' ? `http://${window.location.host}` : `https://${window.location.host}`;
        url = `?template=${tmpl.id}&theme=${tmpl.theme}`
        window.open(url);
    }
    return (
        <div className='container w-full md:w-full pb-16 p-5'>
            <div className="text-5xl font-bold text-center p-10 ">
              <p className='inline uppercase tracking-widest bg-gradient-to-r  from-red-500 to-blue-500 bg-clip-text text-transparent'>
               TEMPLATES
              </p>
            </div>
            <div className=" grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-6 ">
                {getTemplates().map((tmpl, idx) =>
                (
                    <div onClick={() => onSelect(tmpl)} className="p-4  cursor-pointer hover:scale-105 transition-all duration-300  shadow-md flex flex-col items-center border border-gray-200 rounded-md " key={`tmpl_${idx}`}>
                       <div className=' flex-1'>
                        <img src={tmpl.logo}  className={`w-full h-full object-contain `} alt={`${tmpl.id} logo`} />
                       </div>
                        <p  className="text-2xl  py-6 font-semibold basis-10  text-center">{tmpl.id}</p>
                    </div>

                ))}
            </div>
        </div>
    )
}
